import React from 'react';

import { PageTitle } from '../../Text';

export default () => (
  <div className="primary-content">
    <PageTitle>Renewal Requirements</PageTitle>
    <p>
      Tick the box to confirm test passed, there is no need to attach evidence
      of the CITB Health safety & environment test pass.
    </p>
  </div>
);
